import style from './index.module.styl'
const redpackImage = 'https://image.wxopen.shenhudong.com/images/redpack-image.png'
import exchangeMixin from '@/common/js/exchange-mixin.js'
import { AwardDialog } from '@/components/dialog'

export default {
  mixins: [exchangeMixin],
  components: {
    AwardDialog
  },
  render(h) {
    const { redbag, points, browsing } = this.$store.state.currentActivity
    const redBagAward = this.$store.state.redBagAward
    const awardInfo = this.$store.state.awardInfo

    return (
      <div class={style['award']}>
        <div class={style['top-tips']} style={this.$route.params.eventId == 309878?'background-color:rgb(234,23,36)':''}>您在本活动的有效浏览{browsing}人，获得红包{redbag}元，{this.$store.state.keyword}{points}分</div>
        <div class={style['content']}>
          {
            redBagAward.map(d => (
              <div class={[style['item'], style['red']]} key={d.id}>
                <div class={style['left']}>
                  <img src={redpackImage} />
                  {
                    this.$route.params.eventId != 309878 && (<div class={style['text']}>{+d.num > 99 ? '数量充足' : '剩余 ' + d.num}</div>)
                  }
                </div>
                <div class={style['middle']}>
                  <div class={style['item-title']}>微信红包 {!!d.price && `￥${d.price} 元`}</div>
                  <div class={style['desc']}>{d.desc}</div>
                </div>
                <div class={style['right']} data-type="redpack" data-id={d.id} onClick={this.handleOpenExchangeDialog}>
                  <span>详情</span>
                </div>
              </div>
            ))
          }
          {
            awardInfo.map(d => (
              <div class={style['item']}>
                <div class={style['left']}>
                  <img src={d.award_img} />
                  {
                    this.$route.params.eventId != 309878 && (<div class={style['text']}>剩余&nbsp;{d.stock}</div>)
                  }
                </div>
                <div class={style['middle']}>
                  <div class={style['item-title']}>{d.award_name}</div>
                  <div class={style['desc']}>参与任务，达标<span style={`color: red;`}>&nbsp;{d.points}&nbsp;</span>{this.$store.state.keyword}可领取</div>
                </div>
                <div class={style['right']} data-id={d.id} data-type="award" onClick={this.handleOpenExchangeDialog}>
                  <span>详情</span>
                </div>
              </div>
            ))
          }
        </div>
        <div class={style['bottom-tips']}>
          <div class={style['title']}>--&nbsp;&nbsp;规则说明&nbsp;&nbsp;--</div>
          <div class={style['desc-content']}>
            <p>1、请留意页面中关于奖励的详细说明，通常情况下，商家将针对周边有效区域发放福利；</p>
            <p>2、发放后请在商家公众号或微信服务通知中领取，可直接收入微信零钱；</p>
            <p>3、涉嫌刷单行为的用户，或微信标记的不安全用户，将永远失去奖励资格。</p>
          </div>
        </div>
        <AwardDialog
          type={this.awardType}
          id={this.awardId}
          onClickCloseBtn={this.handleCloseExchangeDialog}
          onReceiveAwardSucceed={this.handleExchangeActiveSucceed}
          visible={this.exchangeVisible}
        />
      </div>
    )
  }
}